import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-video-item',
  templateUrl: './video-item.component.html',
  styleUrls: ['./video-item.component.scss']
})
export class VideoItemComponent implements OnInit {

  @Input()  videoItem: any;

  constructor(private router: Router) { }

  ngOnInit() {
    //console.log(JSON.stringify(this.videoItem));
    //console.log(this.getImageThumbnail());
  }

  getImageThumbnail(){
    let locales = this.videoItem.locales[0];
    return "https://media.drbeen.com/"+locales.referenceLocationId+"/"+locales.referenceId+"/"+locales.referenceToken+"/small/thumbnail.jpg";
  }

   /**
   * View seleted course. Take user to video main page
   * //TODO Need to pass video object later
   */
  viewCourse(){
    this.router.navigate(['video/'+this.videoItem._id.$oid]);
  }



}
